/**
 * Employee Information Module Routes
 */

import { Routes, Route } from 'react-router-dom'
import MyProfilePage from './pages/MyProfilePage'
import EmployeeDirectoryPage from './pages/EmployeeDirectoryPage'
import EmployeeDetailPage from './pages/EmployeeDetailPage'
import OrgChartPage from './pages/OrgChartPage'

const EmployeeInfoRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MyProfilePage />} />
      <Route path="/my-profile" element={<MyProfilePage />} />
      <Route path="/directory" element={<EmployeeDirectoryPage />} />
      <Route path="/directory/:employeeId" element={<EmployeeDetailPage />} />
      <Route path="/org-chart" element={<OrgChartPage />} />
    </Routes>
  )
}

export default EmployeeInfoRoutes
